"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
require("antd/lib/page-header/style/css");
var page_header_1 = __importDefault(require("antd/lib/page-header"));
require("antd/lib/table/style/css");
var table_1 = __importDefault(require("antd/lib/table"));
require("antd/lib/space/style/css");
var space_1 = __importDefault(require("antd/lib/space"));
require("antd/lib/button/style/css");
var button_1 = __importDefault(require("antd/lib/button"));
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
    var o, i = p[t], d = G.p, l = i[2];
    r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
} if (o || r > 1)
    return a; throw y = !0, n; } return function (o, p, l) { if (f > 1)
    throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
    i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
    try {
        if (f = 2, i) {
            if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u)))
                    throw TypeError("iterator result is not an object");
                if (!t.done)
                    return t;
                u = t.value, c < 2 && (c = 0);
            }
            else
                1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
            i = e;
        }
        else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a)
            break;
    }
    catch (t) {
        i = e, c = 1, u = t;
    }
    finally {
        f = 1;
    }
} return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() { } function GeneratorFunction() { } function GeneratorFunctionPrototype() { } t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try {
    i({}, "", {});
}
catch (e) {
    i = 0;
} _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try {
    var i = n[a](c), u = i.value;
}
catch (n) {
    return void e(n);
} i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) {
    if ("string" == typeof r)
        return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
} }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++)
    n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) {
    var e, n, i, u, a = [], f = !0, o = !1;
    try {
        if (i = (t = t.call(r)).next, 0 === l) {
            if (Object(t) !== t)
                return;
            f = !1;
        }
        else
            for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0)
                ;
    }
    catch (r) {
        o = !0, n = r;
    }
    finally {
        try {
            if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u))
                return;
        }
        finally {
            if (o)
                throw n;
        }
    }
    return a;
} }
function _arrayWithHoles(r) { if (Array.isArray(r))
    return r; }
var react_1 = __importStar(require("react"));
var react_redux_1 = require("react-redux");
var react_router_dom_1 = require("react-router-dom");
var auth0_react_1 = require("@auth0/auth0-react");
var icons_1 = require("@ant-design/icons");
var config_1 = require("../../config");
var pages_1 = require("../../hooks/pages");
var utils_1 = require("../../utils");
var jsx_runtime_1 = require("@welldone-software/why-did-you-render/jsx-runtime");
var ReleaseListView = /*#__PURE__*/ react_1.default.memo(function () {
    var navigate = (0, react_router_dom_1.useNavigate)();
    var _useAuth = (0, auth0_react_1.useAuth0)(), isAuthenticated = _useAuth.isAuthenticated, getAccessTokenSilently = _useAuth.getAccessTokenSilently;
    var releasesInitialFetch = (0, react_redux_1.useSelector)(function (state) {
        return state.releases.initialFetchDone;
    });
    var releasesFetching = (0, react_redux_1.useSelector)(function (state) {
        return state.releases.isFetching;
    });
    var releases = (0, react_redux_1.useSelector)(function (state) {
        return state.releases.items;
    });
    var _useState = (0, react_1.useState)(false), _useState2 = _slicedToArray(_useState, 2), bundleLoading = _useState2[0], setBundleLoading = _useState2[1];
    // noinspection JSUnusedGlobalSymbols
    var columns = (0, react_1.useMemo)(function () {
        return [{
                title: "Version",
                dataIndex: "version",
                sorter: function sorter(a, b) {
                    return a.version - b.version;
                },
                defaultSortOrder: "descend"
            }, {
                title: "Release Notes",
                dataIndex: "release_notes",
                render: function render(releaseNotes) {
                    return releaseNotes.length < 100 ? releaseNotes : "".concat(releaseNotes.slice(0, 98), "...");
                }
            }, {
                title: "Submitted",
                dataIndex: "submitted_dt",
                render: function render(s) {
                    return new Date(s).toLocaleDateString();
                }
            }, {
                title: "Published",
                dataIndex: "published_dt",
                render: function render(s) {
                    return s ? new Date(s).toLocaleDateString() : "—";
                }
            }, {
                title: "Actions",
                key: "actions",
                render: function render(release) {
                    return (0, jsx_runtime_1.jsxs)(space_1.default, {
                        size: "small",
                        children: [(0, jsx_runtime_1.jsxs)(button_1.default, {
                                icon: (0, jsx_runtime_1.jsx)(icons_1.DownloadOutlined, {}),
                                onClick: (0, utils_1.downloadVersionBundle)(release.version, isAuthenticated, getAccessTokenSilently),
                                children: ["Download Bundle", release.bundle_size ? " (".concat((release.bundle_size / 1000000).toFixed(1), " MB)") : ""]
                            }), (0, jsx_runtime_1.jsx)(button_1.default, {
                                icon: (0, jsx_runtime_1.jsx)(icons_1.EyeOutlined, {}),
                                onClick: function onClick() {
                                    return navigate("../detail/".concat(release.version));
                                },
                                children: "View"
                            })]
                    });
                }
            }];
    }, [isAuthenticated, getAccessTokenSilently, navigate]);
    var onBundle = (0, react_1.useCallback)(function () {
        _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee() {
            var accessToken, res, blob, bundleBlobUrl;
            return _regenerator().w(function (_context) {
                while (1)
                    switch (_context.p = _context.n) {
                        case 0:
                            if (isAuthenticated) {
                                _context.n = 1;
                                break;
                            }
                            return _context.a(2);
                        case 1:
                            setBundleLoading(true);
                            _context.p = 2;
                            _context.n = 3;
                            return getAccessTokenSilently({
                                audience: config_1.AUTH_AUDIENCE,
                                scope: "read:content"
                            });
                        case 3:
                            accessToken = _context.v;
                            _context.n = 4;
                            return fetch("".concat(config_1.API_BASE_URL, "/ad-hoc-bundle"), {
                                headers: (0, utils_1.makeAuthHeaders)(accessToken)
                            });
                        case 4:
                            res = _context.v;
                            if (!res.ok) {
                                _context.n = 6;
                                break;
                            }
                            _context.n = 5;
                            return res.blob();
                        case 5:
                            blob = _context.v;
                            bundleBlobUrl = window.URL.createObjectURL(blob);
                            window.location.href = bundleBlobUrl;
                            window.URL.revokeObjectURL(bundleBlobUrl);
                        case 6:
                            _context.p = 6;
                            setBundleLoading(false);
                            return _context.f(6);
                        case 7:
                            return _context.a(2);
                    }
            }, _callee, null, [[2, , 6, 7]]);
        }))();
    }, [navigate, getAccessTokenSilently]);
    var onAdd = (0, react_1.useCallback)(function () {
        return navigate("../add");
    }, [navigate]);
    var extra = (0, react_1.useMemo)(function () {
        return [(0, jsx_runtime_1.jsx)(button_1.default, {
                icon: (0, jsx_runtime_1.jsx)(icons_1.DownloadOutlined, {}),
                onClick: onBundle,
                loading: bundleLoading,
                children: "Download Ad Hoc Bundle"
            }, "bundle"), (0, jsx_runtime_1.jsx)(button_1.default, {
                type: "primary",
                icon: (0, jsx_runtime_1.jsx)(icons_1.PlusOutlined, {}),
                onClick: onAdd,
                children: "Add Release"
            }, "add")];
    }, [onAdd]);
    var pagination = (0, pages_1.useUrlPagination)();
    return (0, jsx_runtime_1.jsx)(page_header_1.default, {
        ghost: false,
        title: "Releases",
        subTitle: "View and create app releases",
        extra: extra,
        children: (0, jsx_runtime_1.jsx)(table_1.default, {
            bordered: true,
            size: "small",
            loading: !releasesInitialFetch && releasesFetching,
            columns: columns,
            rowKey: "version",
            dataSource: releases,
            pagination: pagination
        })
    });
});
exports.default = ReleaseListView;
